import { Protocol } from '../Protocol';

// DEPRECATE
export class NotificationPriorityProtocol {
  public static readonly ALL_NOTIFICATION_PRIORITY: string = `${Protocol.YATUNG_API_ROOT}/notificationPriority/all`;
}
